import { ArgsProps } from "antd/lib/message";

import { AlertCircleIcon } from "../../assets/icons/AlertCircle";
import { CheckCircleIcon } from "../../assets/icons/CheckCircle";
import style from "./AntMessageConfig.module.scss";

const createConfig = ({
  type,
  content,
  duration,
}: {
  type: "success" | "error" | "warning";
  content: string | JSX.Element;
  duration?: number;
}): ArgsProps => {
  let icon = (
    <span
      role="img"
      aria-label="check-circle"
      className="anticon anticon-check-circle"
    >
      <CheckCircleIcon />
    </span>
  );

  if (type === "error") {
    icon = (
      <span
        role="img"
        aria-label="close-circle"
        className="anticon anticon-close-circle"
      >
        <AlertCircleIcon />
      </span>
    );
  }
  return {
    type,
    content,
    className: style.message,
    duration: duration || 7,
    icon,
  };
};

export default createConfig;
